module.exports = __webpack_public_path__ + "img/asterizco.d5a507bf.png";